var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgWidgetIncassaSubito(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "284px",
    height: "96px",
    viewBox: "0 0 284 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "INCASSA-SUBITO",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(195.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0962101,15.3333333 C50.6912153,15.3333333 51.9842225,16.9122758 51.9842225,18.86 C51.9842225,20.8077242 50.6912153,22.3866667 49.0962101,22.3866667 L75.5008946,22.3866667 C77.0958998,22.3866667 78.388907,23.9656091 78.388907,25.9133333 C78.388907,27.8610576 77.0958998,29.44 75.5008946,29.44 L84.5775049,29.44 C86.1725101,29.44 87.4655172,31.0189424 87.4655172,32.9666667 C87.4655172,34.9143909 86.1725101,36.4933333 84.5775049,36.4933333 L76.7386142,36.4933333 C75.143609,36.4933333 73.8506018,38.0722758 73.8506018,40.02 C73.8506018,41.9677242 75.143609,43.5466667 76.7386142,43.5466667 L79.2140534,43.5466667 C80.8090585,43.5466667 82.1020657,45.1256091 82.1020657,47.0733333 C82.1020657,49.0210576 80.8090585,50.6 79.2140534,50.6 L18.9783669,50.6 C17.3833618,50.6 16.0903546,49.0210576 16.0903546,47.0733333 C16.0903546,45.1256091 17.3833618,43.5466667 18.9783669,43.5466667 L2.88801236,43.5466667 C1.29300718,43.5466667 0,41.9677242 0,40.02 C0,38.0722758 1.29300718,36.4933333 2.88801236,36.4933333 L19.3909401,36.4933333 C20.9859453,36.4933333 22.2789525,34.9143909 22.2789525,32.9666667 C22.2789525,31.0189424 20.9859453,29.44 19.3909401,29.44 L9.07661028,29.44 C7.4816051,29.44 6.18859792,27.8610576 6.18859792,25.9133333 C6.18859792,23.9656091 7.4816051,22.3866667 9.07661028,22.3866667 L25.5795381,22.3866667 C23.9845329,22.3866667 22.6915257,20.8077242 22.6915257,18.86 C22.6915257,16.9122758 23.9845329,15.3333333 25.5795381,15.3333333 L49.0962101,15.3333333 Z M85.9310345,42.9333333 C87.6259773,42.9333333 89,44.4779509 89,46.3833333 C89,48.2887157 87.6259773,49.8333333 85.9310345,49.8333333 C84.2360916,49.8333333 82.862069,48.2887157 82.862069,46.3833333 C82.862069,44.4779509 84.2360916,42.9333333 85.9310345,42.9333333 Z",
    id: "BG",
    fill: "#D8EEF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7337457,58.2652452 C44.5210604,58.6201081 46.3557683,58.6814825 47.683354,58.5827911 M49.8588652,58.3892092 L49.8588652,58.3892092 C51.0100655,58.252626 52.1365164,58.0350489 53.2323937,57.7423181 C55.6426502,57.0984904 57.9050132,56.0911225 59.9575183,54.7823492 C62.0333351,53.4587111 63.8944999,51.8267823 65.4769126,49.9508389 C66.8577195,48.3138983 68.026278,46.4911592 68.9399991,44.5253277 C69.8465054,42.5750184 70.5021829,40.4838675 70.8654435,38.2935773 C71.0819049,36.9884171 71.1945353,35.6480547 71.1945353,34.2813137 C71.1945353,32.2747005 70.9517566,30.3249473 70.4940468,28.459978 C70.0022526,26.4561296 69.2623248,24.5501626 68.3088069,22.7767156 C67.1146548,20.5557133 65.5855043,18.5425577 63.7892069,16.8052868 C62.3915794,15.4535855 60.8322272,14.2688987 59.1431097,13.2832737 C57.2415013,12.1736572 55.1754252,11.3163368 52.9904831,10.7570397 C51.0697856,10.2653833 49.0572346,10.0040241 46.9838073,10.0040241 C44.3781562,10.0040241 41.868645,10.4167795 39.516752,11.180643 C37.2141445,11.9284992 35.0626184,13.0129023 33.1198678,14.3759998 C31.1183231,15.780349 29.3383816,17.4805163 27.8431351,19.413236 C25.9051171,21.9182717 24.4453656,24.8139783 23.6012562,27.9626027 C23.0611351,29.9773161 22.7730793,32.0955829 22.7730793,34.2813137 C22.7730793,37.7511901 23.4990369,41.0510439 24.8069599,44.036487 C26.3975121,47.6670546 28.8487184,50.8326483 31.9016169,53.273594 C34.4638603,55.3222363 37.4499324,56.8604405 40.7067386,57.7346912",
    id: "Shape",
    stroke: "#0090D1",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    transform: "translate(46.983807, 34.314574) rotate(-44.000000) translate(-46.983807, -34.314574) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "bling",
    transform: "translate(65.215517, 5.807460)",
    stroke: "#81C7E4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.37068966,
    y1: 0,
    x2: 5.37068966,
    y2: 2.99,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.37068966,
    y1: 6.97666667,
    x2: 5.37068966,
    y2: 9.96666667,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.79022989,
    y1: 3.44885057,
    x2: 1.79022989,
    y2: 6.51781609,
    id: "Line",
    transform: "translate(1.790230, 4.983333) rotate(-90.000000) translate(-1.790230, -4.983333) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.95114943,
    y1: 3.44885057,
    x2: 8.95114943,
    y2: 6.51781609,
    id: "Line",
    transform: "translate(8.951149, 4.983333) rotate(-90.000000) translate(-8.951149, -4.983333) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "bling",
    transform: "translate(24.551724, 57.174126)",
    stroke: "#81C7E4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.21982759,
    y1: 0,
    x2: 4.21982759,
    y2: 2.10833333,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.21982759,
    y1: 6.325,
    x2: 4.21982759,
    y2: 8.43333333,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.24112576,
    y1: 3.22376606,
    x2: 1.24112576,
    y2: 5.20956728,
    id: "Line",
    transform: "translate(1.241126, 4.216667) rotate(-90.000000) translate(-1.241126, -4.216667) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.19852941,
    y1: 3.22376606,
    x2: 7.19852941,
    y2: 5.20956728,
    id: "Line",
    transform: "translate(7.198529, 4.216667) rotate(-90.000000) translate(-7.198529, -4.216667) "
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\u20AC",
    fontFamily: "Cairo-Regular, Cairo",
    fontSize: 32,
    fontWeight: "normal",
    letterSpacing: 0.24000001,
    fill: "#0090D1"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36.92,
    y: 45
  }, "\u20AC"))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1437126,9 C90.2734813,9 92,10.7460895 92,12.9 C92,15.0539105 90.2734813,16.8 88.1437126,16.8 L66.1077844,16.8 C68.2375532,16.8 69.9640719,18.5460895 69.9640719,20.7 C69.9640719,22.8539105 68.2375532,24.6 66.1077844,24.6 L78.2275449,24.6 C80.3573136,24.6 82.0838323,26.3460895 82.0838323,28.5 C82.0838323,30.6539105 80.3573136,32.4 78.2275449,32.4 L72.6227545,32.4 C69.9373939,32.4 67.760479,34.1460895 67.760479,36.3 C67.760479,37.7359403 68.8622754,39.0359403 71.0658683,40.2 C73.195637,40.2 74.9221557,41.9460895 74.9221557,44.1 C74.9221557,46.2539105 73.195637,48 71.0658683,48 L25.3413174,48 C23.2115486,48 21.4850299,46.2539105 21.4850299,44.1 C21.4850299,41.9460895 23.2115486,40.2 25.3413174,40.2 L3.85628743,40.2 C1.72651869,40.2 0,38.4539105 0,36.3 C0,34.1460895 1.72651869,32.4 3.85628743,32.4 L25.8922156,32.4 C28.0219843,32.4 29.748503,30.6539105 29.748503,28.5 C29.748503,26.3460895 28.0219843,24.6 25.8922156,24.6 L12.1197605,24.6 C9.98999174,24.6 8.26347305,22.8539105 8.26347305,20.7 C8.26347305,18.5460895 9.98999174,16.8 12.1197605,16.8 L34.1556886,16.8 C32.0259199,16.8 30.2994012,15.0539105 30.2994012,12.9 C30.2994012,10.7460895 32.0259199,9 34.1556886,9 L88.1437126,9 Z M88.1437126,24.6 C90.2734813,24.6 92,26.3460895 92,28.5 C92,30.6539105 90.2734813,32.4 88.1437126,32.4 C86.0139438,32.4 84.2874251,30.6539105 84.2874251,28.5 C84.2874251,26.3460895 86.0139438,24.6 88.1437126,24.6 Z",
    id: "Background",
    fill: "#D8EEF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5271654,9.79904198 L62.0585613,47.7629699 L62.0585613,51.5651048 C62.0585613,52.7899739 61.0719792,53.7829266 59.8549685,53.7829266 L27.3519744,53.7829266 C26.1349637,53.7829266 25.1483816,52.7899739 25.1483816,51.5651048 L25.1483816,10.547069 C25.1483816,9.93463438 25.6416727,9.43815806 26.250178,9.43815806 C26.2540219,9.43815806 26.2578657,9.43815806 26.2617093,9.43815806 L28.9548138,9.46658813 M31.132489,9.4895279 L33.6751961,9.51631294",
    id: "Shape",
    stroke: "#0090D1",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    transform: "translate(43.603471, 31.504310) rotate(-7.000000) translate(-43.603471, -31.504310) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9012673,11.9417333 L60.3504898,46.3428929 L60.3478158,49.7882494 C60.3469543,50.8981812 59.4626649,51.7986489 58.3727001,51.7995002 L29.2627498,51.8222353 C28.1727849,51.823086 27.2898922,50.9239985 27.290753,49.8140666 L27.3188398,13.6264742 C27.3196962,12.523121 28.213924,11.6288888 29.3172772,11.6280271 L32.0234853,11.6259136 L32.0234853,11.6259136",
    id: "Rectangle",
    fill: "#81C7E4",
    transform: "translate(43.820621, 31.724074) rotate(-7.000000) translate(-43.820621, -31.724074) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6102436,1.25 C60.3455402,1.25 61.0502124,1.54446527 61.5668895,2.06763436 L61.5668895,2.06763436 L67.9566459,8.53767819 C68.4649619,9.05238122 68.75,9.74664602 68.75,10.4700438 L68.75,10.4700438 L68.75,43 C68.75,43.7593915 68.4421958,44.4468915 67.9445436,44.9445436 C67.4468915,45.4421958 66.7593915,45.75 66,45.75 L66,45.75 L37,45.75 C36.2406085,45.75 35.5531085,45.4421958 35.0554564,44.9445436 C34.5578042,44.4468915 34.25,43.7593915 34.25,43 L34.25,43 L34.25,4 C34.25,3.24060847 34.5578042,2.55310847 35.0554564,2.05545635 C35.5531085,1.55780423 36.2406085,1.25 37,1.25 L37,1.25 Z",
    id: "Rectangle",
    stroke: "#0090D1",
    strokeWidth: 2.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,1 L61,7.35584546 C61,8.26388694 61.7370746,9 62.6463023,9 L67,9",
    id: "Shape",
    stroke: "#0090D1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,9.27884615 L53.5116279,9.27884615 M39,15.9711538 L63,15.9711538 M39,23.2211538 L63,23.2211538 M39,30.4711538 L63,30.4711538 M39,37.9423077 L53.5116279,37.9423077",
    id: "lines",
    stroke: "#0090D1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105,31.9657713 C112.388165,28.2006948 121.801518,29.8441064 133.240057,36.8960062 C150.397867,47.4738557 140.809516,71.1750291 128.358051,64.9843546 C115.906585,58.7936801 127.938011,31.5472997 149.624351,36.5970979 C164.081911,39.96363 175.540461,47.0208599 184,57.7687876",
    id: "Path",
    stroke: "#0090D1",
    strokeDasharray: 3,
    transform: "translate(144.500000, 48.000000) scale(1, -1) translate(-144.500000, -48.000000) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgWidgetIncassaSubito);
export default __webpack_public_path__ + "static/media/imgWidgetIncassaSubito.1e9ee430d08f02074752b86704875502.svg";
export { ForwardRef as ReactComponent };